/*!
 *
 * components.js
 *
 */

'use strict';

require('jquery');
require('jquery.easing');
require('jquery.transit');
require('jquery-mobile-events');
require('slick-carousel');
require('fancybox')($);
require('jquery.cookie');
require('origin');

var linker = require('linker');
var slideScroll = require('slide-scroll');
var acceptTel = require('accept-tel');
var navCurrent = require('nav-current');
require('fit-image');
require('accordion');
var switchFontSize = require('switch-fontsize');
var menu = require('menu');
var page2top = require('page2top');
require('tab');
require('swipe-elem');

$(function(){

	switchFontSize();

	linker.init({
		icon: {
			blank: 'sw-Blank',
			excel: 'sw-Xls',
			word: 'sw-Doc',
			pdf: 'sw-Pdf'
		}
	});

	acceptTel({
		enableClass: 'sw-TelLink-enable',
		disableClass:'sw-TelLink-disable'
	});

	slideScroll({
		easing : 'easeOutExpo',
		speed : 700,
		not: '.sw-NotScroll, #MenuBtn, .faq-List_Label_Link, .mc-Tab_List_Item_Link'
	});

	menu();
	page2top();

	new navCurrent('#Global');

	new navCurrent('#Local .st-Local_List', {
		abs: true
	});

	$('#BannerList').slick({
		arrous: true,
		dots: false,
		infinite: true,
		slidesToShow: 5,
		responsive: [{
			breakpoint: 992,
			settings: {
				slidesToShow: 4
			}
		}, {
			breakpoint: 768,
			settings: {
				slidesToShow: 3
			}
		}, {
			breakpoint: 575,
			settings: {
				slidesToShow: 2
			}
		}],
		prevArrow: '<button type="button" class="slick-prev"></button>',
		nextArrow: '<button type="button" class="slick-next"></button>'
	});

	$('#ContentsMain figure img').fitImages();
	$('.faq-List').accordion({
		head: '.faq-List_Label_Link',
		currentClass: 'faq-List_Label_Link-expanded',
		expandClass: 'faq-List_Body_Inner-expanded'
	});

	$('.mc-Tab').tab({
		cntClass: 'mc-TabContents'
	});

	$('.mc-Duty').swipeElem();

	$('.mc-Staff a').on('tap', function(e){
		e.preventDefault();
		let _href = $(this).attr('href') + '#staff';
		$.fancybox.open(_href, {
			type: 'ajax',
			padding: 0,
			buttons : [
				'close'
			],
			smallBtn : false,
			loop: false,
			infobar: false,
			arrows : false
		});
	});

	if( $('#MainvisSlider').length ){
		$('#MainvisSlider').slick({
			fade: true,
			infinite: true,
			arrows: true,
			dots: false,
			speed: 1000,
			cssEase: 'linear',
			autoplay: true,
			autoplaySpeed: 5000
		});
	};
});


//////////////////
// WEBPACK FOOTER
// ./dev/js/components.js
// module id = 0
// module chunks = 0